import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, Compass, Plus, Radio, User, Bell } from "lucide-react";
import { useUnread } from "@/hooks/useUnread";
import { cn } from "@/lib/utils";

export function MobileNav({ onCreate }) {
  const items = [
    { to: "/home", icon: Home, label: "Home", testid: "mnav-foryou" },
    { to: "/explore", icon: Compass, label: "Explore", testid: "mnav-explore" },
    { type: "create" },
    { to: "/live", icon: Radio, label: "Live", testid: "mnav-live" },
    { to: "/u/me", icon: User, label: "Profile", testid: "mnav-profile" },
  ];
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-around border-t border-am-border bg-am-bg/95 px-2 pb-[env(safe-area-inset-bottom)] pt-2 backdrop-blur-xl md:hidden">
      {items.map((it, i) =>
        it.type === "create" ? (
          <button key="create" onClick={onCreate} data-testid="mnav-create" className="grid h-11 w-11 place-items-center rounded-full p-[1.5px] aura-gradient active:scale-90">
            <span className="grid h-full w-full place-items-center rounded-full bg-am-bg">
              <Plus className="h-6 w-6 text-white" strokeWidth={2.8} />
            </span>
          </button>
        ) : (
          <NavLink
            key={it.to}
            to={it.to}
            data-testid={it.testid}
            className={({ isActive }) =>
              cn("flex flex-1 flex-col items-center gap-0.5 py-1.5 text-[10px] font-medium", isActive ? "text-white" : "text-am-text2")
            }
          >
            {({ isActive }) => (
              <>
                <it.icon className="h-6 w-6" strokeWidth={isActive ? 2.5 : 2} />
                {it.label}
              </>
            )}
          </NavLink>
        )
      )}
    </nav>
  );
}

export function MobileTopBar() {
  const navigate = useNavigate();
  const unread = useUnread();
  return (
    <header className="sticky top-0 z-40 flex items-center justify-between border-b border-am-border bg-am-bg/90 px-4 py-3 backdrop-blur-xl md:hidden">
      <button onClick={() => navigate("/home")} className="flex items-center gap-2">
        <img src="/auramax-logo.png" alt="AuraMax" className="h-8 w-8 rounded-lg" />
        <span className="font-mark text-base font-extrabold tracking-tight">AURAMAX</span>
      </button>
      <button onClick={() => navigate("/notifications")} data-testid="mnav-notifications" className="relative grid h-9 w-9 place-items-center rounded-full text-white hover:bg-white/5">
        <Bell className="h-6 w-6" />
        {unread > 0 && <span className="absolute right-0 top-0 grid h-4 min-w-4 place-items-center rounded-full aura-gradient px-1 text-[9px] font-bold text-black">{unread > 9 ? "9+" : unread}</span>}
      </button>
    </header>
  );
}
